import type { Exposure } from '~/types/person/details';

/**
 * The exposure list endpoints name the identifier `exposure_id`; the single-exposure endpoint —
 * and the `Exposure` type — name it `id`. The drawer fetches by whichever one it is handed, so
 * every opener has to resolve it the same way.
 */
export type ExposureWithApiId = Exposure & { exposure_id?: string };

export const exposureId = (exposure: ExposureWithApiId): string => exposure.exposure_id ?? exposure.id;
